import React from 'react'
import Table from 'react-bootstrap/Table';
import social from "../assets/social.png"
import view from "../assets/view.png"
import del from "../assets/del.png"
import star from "../assets/star.png"
import edit from "../assets/edit.png"
import { MonitorData } from '../Info/Previewarray';
import pen from "../assets/pen.png"
import block from "../assets/block.png"

function MonitorRestrictedtable() {
    return (<>
        <Table responsive className='table mt-5' style={{ background: "#fff" }}>
            <tbody style={{ backgroundColor: "#fff", position: 'relative' }}>
                <tr className='head_table ps-3' >

                    <td>
                        <p className='table_data' >Posted By</p></td>
                    <td>
                        <p className='table_data2' style={{ width: "250px" }}>Profile</p>
                    </td>
                    <td>
                        <p className='table_data6' style={{ width: "250px" }}>Date Added</p>

                    </td>
                    <td>
                        <p className='table_data5 ms-3' style={{ width: "450px" }}>Post</p>
                    </td>
                    <td>
                        <p className='table_data'>Actions</p>
                    </td>

                </tr>
                <tr style={{ height: "10px" }}></tr>
                <tr style={{ height: "10px" }}></tr>
                {MonitorData.map((e) => {
                    return (<>
                        <tr style={{ border: "1px solid transparent" }}>
                            <td >
                                <div className='pt-2' >
                                    <p className='table_text '>{e.num}</p>
                                    <div className='d-flex align-items-center gap-2'>
                                        <p className='table_link' style={{ color: "black" }}>{e.link}</p>
                                        <img src={social} />
                                    </div>
                                </div>
                            </td>
                            <td>
                                <p className='table_text '>{e.name}</p>
                            </td>
                            <td>
                                <div>
                                    <p className='table_text'>{e.data}</p>
                                    <p className='table_text2'>{e.dname}</p>
                                </div>
                            </td>
                            <td>
                                <div className='d-flex align-items-center gap-3'>
                                    <img src={e.img} />
                                    <p className='copyright_text'>Copyrighted post detected</p>
                                </div>

                            </td>
                            <td>
                                <div className='d-flex gap-2 align-items-center mt-4'>
                                    <img src={block} />
                                    <img src={pen} />
                                    <img src={del} />
                                </div>
                            </td>
                        </tr>


                    </>)
                })}
            </tbody>
        </Table>





    </>

    )
}

export default MonitorRestrictedtable